import { render, staticRenderFns } from "./OnlineDriversWithoutTripsTable.vue?vue&type=template&id=7155bdb8&"
import script from "./OnlineDriversWithoutTripsTable.vue?vue&type=script&lang=js&"
export * from "./OnlineDriversWithoutTripsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports